import { render, staticRenderFns } from "./OldBlockResvOption.vue?vue&type=template&id=6f28b516&scoped=true"
import script from "./OldBlockResvOption.vue?vue&type=script&lang=js"
export * from "./OldBlockResvOption.vue?vue&type=script&lang=js"
import style0 from "./OldBlockResvOption.vue?vue&type=style&index=0&id=6f28b516&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f28b516",
  null
  
)

export default component.exports